import FooterComponent from './m1_footer.vue'
const ataFooter = {
    install: function(Vue){
        Vue.component('ataFooter',FooterComponent)
    }
}
export default ataFooter